var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-card',_vm._g(_vm._b({attrs:{"tabs":_vm.tabs}},'page-card',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,slot){return _c('template',{slot:slot},[_vm._t(slot)],2)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }